import { render, staticRenderFns } from "./Paymentmethods.vue?vue&type=template&id=7c7a1f0d"
import script from "./Paymentmethods.vue?vue&type=script&lang=js"
export * from "./Paymentmethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports